import { coerceBooleanProperty } from "@angular/cdk/coercion";
import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { TestId } from "pax-ui/core";
import { IconArrowLeft, IconRegistryService, PaxIcon } from "pax-ui/icons";

import { Button } from "../button";

@Component({
  selector: "pax-top-navigation-panel",
  standalone: true,
  imports: [CommonModule, Button],
  templateUrl: "./top-navigation-panel.html",
  styleUrls: ["./top-navigation-panel.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopNavigationPanel {
  @Input({ transform: coerceBooleanProperty })
  enableBackButton!: boolean;

  @Input()
  backButtonText = $localize`Zurück`;

  @Output()
  back = new EventEmitter<void>();

  backButtonArrowLeft: PaxIcon = IconArrowLeft;

  backButtonTestId = TestId.BACK_BUTTON;

  constructor(readonly iconRegistryService: IconRegistryService) {
    iconRegistryService.registerIcons([this.backButtonArrowLeft]);
  }

  onBack() {
    this.back.emit();
  }
}
